import { useState } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Box, Chip, Popover, Typography, UserAvatar, pxToRem } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
export function SharedViewInformation(props) {
    const { label, description, userName, userEmail } = props;
    const [open, setOpen] = useState(false);
    const safeUsername = userName || t({ message: 'Deleted user', comment: 'Fallback username' });
    const createdBy = t({
        message: 'Shared by',
        comment: 'Saved views: Created by label',
        context: 'saved-view',
    });
    const descriptionFallback = t({
        message: 'No description given for this view',
        comment: 'Saved views: Description fallback',
        context: 'saved-view',
    });
    return (<Popover open={open} onClose={() => setOpen(false)} target={<Chip onClick={() => setOpen(!open)} icon={<Falcon icon="exclamation-circle"/>} label={label} appearance="secondary"/>}>
      <Box flexDirection="column">
        <Box flexDirection="column" gap="sm" mb="lg" maxWidth={pxToRem(256)}>
          <Typography $fontWeight="medium">
            <Trans comment="Shared chip popover label" context="saved-view">
              Shared view
            </Trans>
          </Typography>

          <Typography $color="text.200">{description || descriptionFallback}</Typography>
        </Box>

        <Box flexDirection="column" gap="sm">
          <Typography $fontSize="small" $appearance="200">
            {createdBy}
          </Typography>

          <UserAvatar title={safeUsername} subtitle={userEmail || ''} size="sm"/>
        </Box>
      </Box>
    </Popover>);
}
